<!-- accordeon.component.html -->
<div class="accordion-item">
  <div class="accordion-header" (click)="toggleExpand()">
    <div class="header-content text-sm items-center">
      <span class="delivery-time"><span class="font-semibold">{{'#' + order().id}}</span> ({{this.formatDate(order().deliveryDate)}})</span>
      @if (order().mealmoment && order().mealmoment.name) {
        <span class="">&nbsp;{{'- ' + order().mealmoment.name}}</span>
      }
      @if (this.historyWithData().includes(order())) {
        <span class="material-icons material-symbols-outlined ml-auto fg-orange-1">star_half</span>
      }
      <span [class.ml-auto]="!this.historyWithData().includes(order())" class="mr-2 rounded-full w-4 h-4 block my-auto {{'status-' + this.order().status}}" ></span>
      @if (this.isAcceptPayment()) {
        <span class="price">{{order().price | currency:'EUR'}}</span>
      }
    </div>
    <span class="expand-icon">{{ order().isExpanded ? '▼' : '▶' }}</span>
  </div>

  @if (order().isExpanded) {
    <div class="accordion-content">
      <div class="content-row">
        <strong>Status:</strong> {{this.computeStatusState(order())?.name || 'inconnu'}}
      </div>
      <div class="content-row">
        <strong>Convive:</strong> {{order().child_name || this.getUsername()}}
      </div>
      @if (order().mealmoment && order().mealmoment.name) {
        <div class="content-row">
          <strong>Moment repas:</strong> {{order().mealmoment.name}}
        </div>
      }
      @if (order().enterprise && order().enterprise.name) {
        <div class="content-row">
          <strong>Lieu de consommation:</strong> {{order().enterprise.name}}
        </div>
      }
      @if (order().comment?.trim()?.length) {
        <p class="content-row">
          <strong>Commentaire:</strong> {{order().comment}}
        </p>
      }
      <div class="content-row">
        <strong>Articles commandés:</strong>
        <ul>
          @for (item of order().orderItems; track item) {
            <li>
              {{item.quantity}}x {{item.serviceContent}} {{this.isAcceptPayment() ? ('- ' + (item.price | currency:'EUR')) : ('')}}
            </li>
          }
        </ul>
      </div>
      @if (this.isAcceptPayment()) {
        <div class="content-row">
          <strong>Détails du prix:</strong>
          <div class="price-details">
            <div>Prix HT: {{order().priceWithoutVat | currency:'EUR'}}</div>
            <div>TVA ({{order().vat}}%): {{order().price - order().priceWithoutVat | currency:'EUR'}}</div>
            <div>Prix total: {{order().price | currency:'EUR'}}</div>
          </div>
        </div>
      }
      <div class="content-row">
        <mk-action-button class="w-full h-[40px] block"  [enabled]="this.isCancellable(order())" baseLabel="Annuler la commande" baseIcon="delete" [data]="order()" [callback]="this._handler_cancelOrder" />
        @if (this.isAcceptPayment()) {
          <mk-action-button class="w-full h-[40px] block mt-1" [enabled]="true" baseLabel="Facture" baseIcon="download" [data]="order()" [callback]="this._handler_facture"/>
        }
        <mk-action-button class="w-full h-[40px] block mt-1" [classes]="this.historyWithData().includes(order()) ? 'fg-orange-1' : ''"   [enabled]="order().status === 'valid'" baseLabel="Noter / Commenter" [baseIcon]="this.historyWithData().includes(order()) ? 'star_half' : 'star'" [data]="order()" [callback]="this._handler_openNotation"/>
      </div>
    </div>
  }
</div>
